import { datadogRum } from '@datadog/browser-rum';
import { ENVIRONMENT } from '@updater-core/lib/environment';

if (
  typeof window !== 'undefined' &&
  !(window.Cypress || window.parent.Cypress)
) {
  datadogRum.init({
    applicationId: 'eb8fe527-d5ca-4922-9008-9a3fd51cb5a0',
    clientToken: 'pub8a79afc5eebe563878776cf489980476',
    site: 'datadoghq.com',
    service: 'mover-app',
    version: global.__COMMIT_HASH__, // eslint-disable-line
    env: ENVIRONMENT.name,
    sampleRate: 100,
    trackInteractions: true,
    allowedTracingOrigins: [/.*api.*updater.com.*/, /.*bridgevine.io.*/],
    beforeSend: (event) => {
      if (window.FS) {
        const fsSessionUrl = window.FS.getCurrentSessionURL();
        event.context.fullStoryUrl = fsSessionUrl; // eslint-disable-line
      }
    },
  });
}
